const endpoints = {
  WEBSOCKET_AGENT_CREATE: '/v2/websocket/agent/create',
  WEBSOCKET_AGENT_REAUTHORIZE: '/v2/websocket/agent/reAuthorize',
  AGENT_LEAVE: '/v2/ccp/me/leave',
  AGENT_GET_NR_OF_CONNECTIONS: '/v2/ccp/me/getNumberOfConnectionsForAgent',
  AGENT_BACK: '/v2/ccp/me/back',
  CCP_REQUEST_CONVERSATIONS: '/v2/ccp/requestConversations',
  CCP_GET_CONFIG: '/v2/ccp/me/getConfig',
  CCP_GET_CONVERSATIONS_FOR_EMAIL: '/v2/ccp/getConversationsForEmail',
  CCP_CONVERSATION_TRANSFER: '/v2/ccp/conversation/transfer',
  CCP_CONVERSATION_SOFT_DETACH: '/v2/ccp/conversation/softDetachConversation',
  CCP_CONVERSATION_DETACH: '/v2/ccp/conversation/detachConversation',
  CCP_GET_ATTACHED_CONVERSATIONS: '/v2/agent/attachedConversations',
  CCP_CONVERSATION_SUMMARY: '/v2/ccp/conversation/summary',
}

export class Agent {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async authorize(opts) {
    return this.requester.post(endpoints.WEBSOCKET_AGENT_CREATE, {}, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async reAuthorize({ page },opts) {
    return this.requester.get(endpoints.WEBSOCKET_AGENT_REAUTHORIZE, { page: page }, { ...opts, excludeHeaders: ['x-safemode'] })
  }

  async getNumberOfConnectionsForAgent(opts) {
    return this.requester.get(endpoints.AGENT_GET_NR_OF_CONNECTIONS, {}, opts)
  }

  async leave(isAgentOnBreak, opts) {
    return this.requester.post(endpoints.AGENT_LEAVE, { isAgentOnBreak }, opts)
  }

  async back(opts) {
    return this.requester.post(endpoints.AGENT_BACK, {}, opts)
  }

  async fetchMoreConversations({ conversationsLength, extraConversations, manual }, opts) {
    return this.requester.get(endpoints.CCP_REQUEST_CONVERSATIONS, { conversationsLength, extraConversations, manual }, opts)
  }

  async fetchConfig(opts) {
    return this.requester.get(endpoints.CCP_GET_CONFIG, {}, opts)
  }

  async getConversationsForEmail(userUid, opts) {
    return this.requester.get(endpoints.CCP_GET_CONVERSATIONS_FOR_EMAIL, { userUid }, opts)
  }

  async transferAttachedConversation(conversationId, targetAgentId, opts) {
    return this.requester.post(endpoints.CCP_CONVERSATION_TRANSFER, { conversationId, targetAgentId }, opts)
  }

  async softDetachConversation(conversationUid, opts) {
    return this.requester.post(endpoints.CCP_CONVERSATION_SOFT_DETACH, { conversationUid }, opts)
  }

  async detachConversation({ conversationUid, manual }, opts = {}) {
    return this.requester.post(endpoints.CCP_CONVERSATION_DETACH, { conversationUid, manual }, opts)
  }

  async fetchAttachedConversations(agentId, opts) {
    return this.requester.get(endpoints.CCP_GET_ATTACHED_CONVERSATIONS, { agentId }, opts)
  }

  async getConversationSummary(conversationUid, forceRefresh, opts) {
    return this.requester.get(endpoints.CCP_CONVERSATION_SUMMARY, { conversationUid, forceRefresh }, opts)
  }
}
